/**
 * IMPORTANT:
 * $html-font-size affects bulma's grid, since it's based on rem units.
 * Keep that in mind, if you're intent on changing it.
 */
/*
 * Color Palette
 *
 * The color palette is generally not meant for usage in component's style
 * It should be used mainly for the values of the CSS variables on themes.
 *
 * However, when should not change based on the active theme, use them directly.
 */
:root {
  --ip-colors-basic-black: #000;
  --ip-colors-basic-white: #fff;
  --ip-colors-basic-black-contrast: #fff;
  --ip-colors-basic-white-contrast: #fff;
  --ip-colors-dark-base: #373737;
  --ip-colors-dark-medium: #4c4c4c;
  --ip-colors-dark-light: #5f5f5f;
  --ip-colors-primary-base: #fbf315;
  --ip-colors-primary-medium: #fbf769;
  --ip-colors-primary-light: #fcf99b;
  --ip-colors-grey-dark: #909090;
  --ip-colors-grey-base: #e0e0e0;
  --ip-colors-grey-medium: #eee;
  --ip-colors-grey-light: #f5f5f5;
  --ip-colors-grey-background: #fbfbfb;
  --ip-colors-raiffeisen-blue: #0075bf;
  --ip-colors-raiffeisen-red: #f00;
  --ip-colors-raiffeisen-green: #00b341;
  --ip-colors-raiffeisen-violett: #6c4796;
  --ip-colors-raiffeisen-turquoise: #009ba4;
  --ip-colors-gds-surface-level-0: #f1ede6;
  --ip-colors-gds-surface-level-2-alt-01: #f8f6f2;
  --ip-colors-gds-surface-level-2-alt-02: #f1ede6;
  --ip-colors-gds-border-weak: rgba(43, 45, 51, 0.3);
  --ip-colors-gds-border-weaker: rgba(43, 45, 51, 0.2);
  --ip-colors-gds-border-default: #2b2d33;
  --ip-colors-gds-bg-dropshadow: rgba(43, 45, 51, 0.2);
  --ip-colors-dropshadow-default: rgba(0, 0, 0, 0.1);
}

.high-contrast {
  --ip-colors-basic-black: #000;
  --ip-colors-basic-white: #fff;
  --ip-colors-basic-black-contrast: #000;
  --ip-colors-basic-white-contrast: #fff;
  --ip-colors-dark-base: #000;
  --ip-colors-dark-medium: #f5f5f5;
  --ip-colors-dark-light: #000;
  --ip-colors-primary-base: #fbf315;
  --ip-colors-primary-medium: #fbf769;
  --ip-colors-primary-light: #fcf99b;
  --ip-colors-grey-dark: #000;
  --ip-colors-grey-base: #f5f5f5;
  --ip-colors-grey-medium: #fff;
  --ip-colors-grey-light: #fff;
  --ip-colors-grey-background: #fff;
  --ip-colors-raiffeisen-blue: #0075bf;
  --ip-colors-raiffeisen-red: #f00;
  --ip-colors-raiffeisen-green: #00b341;
  --ip-colors-raiffeisen-violett: #6c4796;
  --ip-colors-raiffeisen-turquoise: #009ba4;
}

body {
  background-color: var(--ip-colors-basic-white);
  margin: 0;
}

a,
button {
  text-decoration: none;
  color: var(--ip-colors-dark-base);
}

:host {
  display: block;
  --ip-min-width-medium-up: none;
}
:host oh-icon-button {
  display: block;
}
:host .overlay {
  z-index: 600;
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
}
:host .overlay.open {
  display: flex;
}
:host .modal__container {
  padding: 1.25rem;
  padding-top: 5rem;
  background-color: var(--ip-colors-basic-white);
  position: relative;
  width: calc(100% - 40px);
  margin: 1.25rem;
  max-width: 20.9375rem;
  box-sizing: border-box;
  max-height: 90%;
  overflow-y: auto;
}
@media (min-width: 37.5rem) {
  :host .modal__container {
    min-width: var(--ip-min-width-medium-up);
    max-width: 25rem;
    padding: 2rem;
    padding-top: 5rem;
  }
}
:host .modal__container.extended-width {
  max-width: 40.625rem;
}
:host .modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.75rem;
  cursor: pointer;
  z-index: 600;
}
:host .modal__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
}
:host .modal__content h3 {
  margin: 0;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
:host .modal__content p {
  color: var(--ip-colors-grey-dark);
  margin: 0;
  font-size: 1rem;
  line-height: 1.5rem;
}
:host .modal__slot {
  margin-top: 3rem;
}
:host .modal__slot.reduced-margin {
  margin-top: 1.5rem;
}
:host .modal__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
  gap: 1rem;
}
:host .modal__actions__column {
  flex: 1;
}
:host .modal__actions__column.right {
  display: flex;
  justify-content: end;
}